import React from 'react';
import { useHistory } from "react-router-dom";
import { Messages } from 'primereact/messages';

export const ValidateTokenForgotPasswordPage = (props) => {

    let history = useHistory();
    const message = React.useRef();

    const showFailed = (msg) => {
        message.current.show({ severity: 'error', content: msg, life: 90000 });
    };

    React.useEffect(function() {
        console.log("1", window.location.pathname);
        console.log("2", window.location.href);
        console.log("3", history.location.pathname);
        console.log("4", props.location);
        console.log("5", props.match);
        console.log("6", props.history);
        console.log("7", props.match.params);
        console.log("8", props.match.params[0]);        

        const requestPayload =  {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*', 
            }
        }
        
        fetch('https://springboot-widy-app.widyan123.site/widy-app/forgot-password/is-valid-token/'+props.match.params[0], requestPayload)
        .then(response => {
            if(response.status === 200) {
                setTimeout(() => {
                    history.push({
                        pathname: '/change-password',
                        state: {
                            token: props.match.params[0]
                        }
                    });
                }, 0);
            } else if(response.status === 401) {
                return Promise.reject(response);
            } else {
                return Promise.resolve(response);
            }
        })
        .then(response => response.json())
        .then(response => {
            showFailed(response.message);
        })
        .catch(response => {
            history.push('/login');
        });
    }, []);

    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">
                    <h5>Validate Token Forgot Password Page</h5>
                    <p>Use this page to start from scratch and place your custom content.</p>
                    <Messages ref={message} />                    
                </div>
            </div>
        </div>
    );
}
